<mat-card class="menupannel">
  <div class="resUser">
    <div class="usernameinfo" (click)="openUserDetail()">
      <div class="picname">
        <div class="pic">
          <ng-container *ngIf="ImagePathURL.substring(0, 4) == 'http'; else showName">
            <img src="{{ ImagePathURL }}" />
          </ng-container>
          <ng-template #showName>
            <span class="shortName">
              {{ getShortName(transactionUserName) }}</span>
          </ng-template>
        </div>
        <div class="name">
          <h3>{{ transactionUserName }}</h3>
          <p>{{ transactionUserRole }}</p>
        </div>
      </div>
    </div>
    <button mat-icon-button (click)="openUserDetail()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>
  <div class="d">
    <button mat-flat-button (click)="openContactList()">
      <mat-icon>keyboard_arrow_left</mat-icon> Contacts
    </button>
  </div>
</mat-card>

<div class="coreholder" fxLayout="row">
  <!-- User Detail -->
  <mat-card class="userdetails" [ngClass]="{ open: showUserDetail, expand: expandUserInfo }">
    <div class="forExpansion">

    
    <div class="usernameinfo">
      <div class="picname">
        <div class="pic">
          <ng-container *ngIf="ImagePathURL.substring(0, 4) == 'http'; else showName">
            <img src="{{ ImagePathURL }}" />
          </ng-container>
          <ng-template #showName>
            <span class="shortName">{{getShortName(transactionUserName)}}</span>
          </ng-template>
          <div class="picuploader">
            <input type="file" alt="" (change)="onSelectFile($event)" />
            <mat-icon>camera_alt</mat-icon>
          </div>
        </div>
        <div class="name">
          <h3>{{ transactionUserName }}</h3>
          <p>{{ transactionUserRole }}</p>
        </div>
      </div>

      <div class="pmenu">
        <button mat-icon-button color="primary" (click)="expandUserDetail()" >
          <mat-icon *ngIf="!expandUserInfo" >chevron_right</mat-icon>
          <mat-icon *ngIf="expandUserInfo">chevron_left</mat-icon>
        </button>
        <!-- <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button mat-menu-item>Profile Settings</button>
          <button mat-menu-item>Delete</button>
        </mat-menu> -->
      </div>
    </div>

    <div class="compdetail">
      <form [formGroup]="myFormGroup">
        <ng-container *ngFor="let field of coreUserList">
          <div *ngIf="field.fieldID==0 && field.data.length>0" class="fullw groupHolder"
            [ngSwitch]="field.fieldTypeName">
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{field.data[0].groupName}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div *ngFor="let grpField of field.data">

                <div *ngIf="grpField.fieldID>0" class="fullw" [ngSwitch]="grpField.fieldTypeName">
                  <ng-container *ngSwitchCase="'Textbox'">
                    <ng-container *ngIf="grpField.fieldName == 'Name'">
                      <mat-form-field>
                        <input matInput [required]="grpField.isRequired" placeholder="{{ grpField.fieldName }}"
                          [(ngModel)]="transactionUserName" formControlName="{{ grpField.fieldName }}"
                          [readonly]="grpField.rolePermission==1" />


                      </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="grpField.fieldName != 'Name'">
                      <ng-container *ngIf="grpField.fieldNames.length > 0">
                        <div class="multipleBlock">
                          <div class="multype">
                            <div class="primaryEmail">
                              <mat-form-field class="mulDropdown" appearance="">
                                <mat-select (selectionChange)="clearPlaceholder($event)"
                                  formControlName="{{ grpField.fieldName + 'option' }}"
                                  placeholder="{{ grpField.placeholderVal }}">
                                  <mat-option value="{{ names.fieldNameID }}" *ngFor="let names of grpField.fieldNames">
                                    {{ names.fieldName }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                              <ng-container *ngIf="grpField.fieldName == 'Email'">
                                <div class="setPrimaryactive" matTooltipClass="tooltip"
                                  *ngIf=" grpField.isPrimary == true" (click)="MakePrimaryParent($event,grpField)">
                                  Primary</div>
                                <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip"
                                  *ngIf=" grpField.isPrimary == false" (click)="MakePrimaryParent($event,grpField)">
                                  Primary</div>
                              </ng-container>
                            </div>

                            <mat-form-field>
                              <input [required]="grpField.isRequired" *ngIf="grpField.fieldName == 'Phone'" matInput
                                placeholder="Add Phone" [(ngModel)]="grpField.fieldValue"
                                formControlName="{{ grpField.fieldName }}" mask="(000) 000-0000"
                                [readonly]="grpField.rolePermission==1" />

                              <input [required]="grpField.isRequired" *ngIf="grpField.fieldName != 'Phone'" matInput
                                placeholder="Add {{ grpField.placeholder }}" [(ngModel)]="grpField.fieldValue"
                                formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                            </mat-form-field>

                            <div class="inOline" *ngIf="grpField.fieldName == 'Address'">

                              <div class="divide">
                                <mat-form-field>
                                  <input type="text" placeholder="City" [(ngModel)]="cityValue" aria-label="Number"
                                    matInput (input)="searchCity($event.target.value)" formControlName="City"
                                    [matAutocomplete]="auto" [readonly]="grpField.rolePermission==1">
                                  <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let option of cityOption" [value]="option">
                                      {{option}}
                                    </mat-option>
                                  </mat-autocomplete>
                                </mat-form-field>
                              </div>

                              <div class="divide">
                                <mat-form-field>
                                  <mat-select [disabled]="grpField.rolePermission==1" [(ngModel)]="stateValue"
                                    formControlName="State" placeholder="State">
                                    <mat-option>None</mat-option>
                                    <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>

                              <div class="divide">
                                <mat-form-field>
                                  <input type="text" placeholder="Zip Code" aria-label="Number" [(ngModel)]="zipValue"
                                    matInput (input)="searchZip($event.target.value)" formControlName="ZipCode"
                                    [matAutocomplete]="ZipCode" [readonly]="grpField.rolePermission==1">
                                  <mat-autocomplete #ZipCode="matAutocomplete">
                                    <mat-option *ngFor="let option of zipOption" [value]="option">
                                      {{option}}
                                    </mat-option>
                                  </mat-autocomplete>
                                </mat-form-field>
                              </div>


                            </div>


                          </div>
                          <span class="addmore" (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0">
                            Add more</span>
                        </div>

                        <div class="multipleBlock" *ngIf="grpField.fieldName == 'Email'">

                          <div class="multype" *ngFor="let element of dynamicArray; let i = index">
                            <div class="primaryEmail">
                              <mat-form-field class="mulDropdown" appearance="">
                                <mat-select (selectionChange)="clearPlaceholder($event)"
                                  formControlName="{{element.fieldName + 'option'}}"
                                  placeholder="{{ element.placeholderVal }}">
                                  <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                    let names of element.fieldNames;
                                    trackby: fieldNameID">{{ names.fieldName }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                              <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip"
                                *ngIf="element.isPrimary == false" (click)="MakePrimaryChild($event,element)"> Primary
                              </div>
                              <div class="setPrimaryactive" matTooltipClass="tooltip" *ngIf="element.isPrimary == true">
                                Primary</div>
                            </div>

                            <mat-form-field>
                              <input matInput placeholder="Add Email" [(ngModel)]="element.fieldValue"
                                formControlName="{{ element.fieldName}}" [readonly]="grpField.rolePermission==1"
                                pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}" required />
                            </mat-form-field>


                          </div>
                          <span class="addmore" (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0">
                            Add more</span>
                        </div>

                        <div class="multipleBlock" *ngIf="grpField.fieldName == 'Phone'">
                          <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                            <mat-form-field class="mulDropdown" appearance="">
                              <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                  element.fieldName  + 'option'
                                }}" placeholder="{{ grpField.fieldNames[0].fieldName }}">
                                <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                    let names of element.fieldNames;
                                    trackby: fieldNameID
                                  ">{{ names.fieldName }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput mask="(000) 000-0000" [(ngModel)]="element.fieldValue"
                                placeholder="Add Phone" formControlName="{{ element.fieldName }}"
                                [readonly]="grpField.rolePermission==1" />
                            </mat-form-field>


                          </div>
                          <span class="addmore" (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0">
                            Add more</span>
                        </div>

                        <div class="multipleBlock" *ngIf="grpField.fieldName == 'Address'">
                          <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                            <mat-form-field class="mulDropdown" appearance="">
                              <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                formControlName="{{
                                  element.fieldName + 'option'
                                }}" placeholder="{{ element.placeholderVal }}">
                                <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                    let names of element.fieldNames;
                                    trackby: fieldNameID
                                  ">{{ names.fieldName }}</mat-option>
                              </mat-select>
                            </mat-form-field>

                            <mat-form-field>
                              <input matInput placeholder="Add Address" [(ngModel)]="element.fieldValue"
                                formControlName="{{ element.fieldName }}" [readonly]="grpField.rolePermission==1" />
                            </mat-form-field>

                            <div *ngIf="element.address.length>0" class="inOline">
                              <ng-container *ngFor="let adr of element.address;">

                                <!-- <div class="divide">
                                <mat-form-field> -->
                                <input *ngIf="adr.childFieldType==3" placeholder="City" aria-label="Number" matInput
                                  [ngModel]="adr.fieldValue" (input)="searchCity($event.target.value)"
                                  formControlName="City{{(i + 1) }}" [matAutocomplete]="auto"
                                  [readonly]="grpField.rolePermission==1">
                                <mat-autocomplete #auto="matAutocomplete">
                                  <mat-option *ngFor="let option of cityOption" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete>
                                <!-- </mat-form-field>
                            </div> -->

                                <!-- <div class="divide">
                                <mat-form-field> -->
                                <mat-select [disabled]="grpField.rolePermission==1" [ngModel]="adr.fieldValue"
                                  *ngIf="adr.childFieldType==2" formControlName="State{{ (i + 1) }}"
                                  placeholder="State">
                                  <mat-option>None</mat-option>
                                  <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                </mat-select>
                                <!-- </mat-form-field>
                              </div> -->


                                <!-- <div class="divide">
                                <mat-form-field> -->
                                <input *ngIf="adr.childFieldType==4" placeholder="Zip Code" [ngModel]="adr.fieldValue"
                                  aria-label="Number" matInput (input)="searchZip($event.target.value)"
                                  formControlName="ZipCode{{ (i + 1) }}" [matAutocomplete]="ZipCode"
                                  [readonly]="grpField.rolePermission==1">
                                <mat-autocomplete #ZipCode="matAutocomplete">
                                  <mat-option *ngFor="let option of zipOption" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete>
                                <!-- </mat-form-field>
                              </div> -->


                              </ng-container>
                            </div>
                            <div *ngIf="element.address.length==0" class="inOline">

                              <div class="divide">
                                <mat-form-field>
                                  <input placeholder="City" aria-label="Number" matInput
                                    (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                                    [matAutocomplete]="auto" [readonly]="grpField.rolePermission==1">
                                  <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let option of cityOption" [value]="option">
                                      {{option}}
                                    </mat-option>
                                  </mat-autocomplete>
                                </mat-form-field>
                              </div>

                              <div class="divide">
                                <mat-form-field>
                                  <mat-select [disabled]="grpField.rolePermission==1"
                                    formControlName="State{{ (i + 1) }}" placeholder="State">
                                    <mat-option>None</mat-option>
                                    <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>

                              <div class="divide">
                                <mat-form-field>
                                  <input placeholder="Zip Code" aria-label="Number" matInput
                                    (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                                    [matAutocomplete]="ZipCode" [readonly]="grpField.rolePermission==1">
                                  <mat-autocomplete #ZipCode="matAutocomplete">
                                    <mat-option *ngFor="let option of zipOption" [value]="option">
                                      {{option}}
                                    </mat-option>
                                  </mat-autocomplete>
                                </mat-form-field>
                              </div>




                            </div>

                          </div>
                          <span class="addmore" (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0">
                            Add more</span>
                        </div>

                        <div class="multipleBlock" *ngIf="grpField.fieldName == 'WebSite'">
                          <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                            <mat-form-field class="mulDropdown" appearance="">
                              <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                  element.fieldName + 'option'
                                }}">
                                <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                    let names of element.fieldNames;
                                    trackby: fieldNameID
                                  ">{{ names.fieldName }}</mat-option>
                              </mat-select>
                            </mat-form-field>


                            <mat-form-field>
                              <input matInput placeholder="WebSite" [(ngModel)]="element.fieldValue"
                                formControlName="{{ element.fieldName }}" [readonly]="grpField.rolePermission==1" />
                            </mat-form-field>


                          </div>
                          <span class="addmore" (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0">
                            Add more</span>
                        </div>
                      </ng-container>

                      <mat-form-field *ngIf="grpField.fieldNames.length === 0">
                        <mat-label>{{ grpField.fieldName }}</mat-label>
                        <input matInput [required]="grpField.isRequired" placeholder="Add {{ grpField.fieldName }}"
                          formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                      </mat-form-field>
                    </ng-container>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Textarea'">
                    <mat-form-field>
                      <textarea [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                        formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1"></textarea>
                    </mat-form-field>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Number'">
                    <mat-form-field>
                      <input [required]="grpField.isRequired" matInput (keypress)="numberOnly($event)"
                        placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}"
                        [readonly]="grpField.rolePermission==1" />
                    </mat-form-field>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Currency'">
                    <mat-form-field>
                      <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                        formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                    </mat-form-field>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Address'">
                    <mat-form-field>
                      <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                        formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                    </mat-form-field>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Image'">
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <div class="pic">
                      <input type="file" placeholder="{{ grpField.fieldName }}"
                        formControlName="{{ grpField.fieldName }}" (change)="onSelectFile($event)"
                        [readonly]="grpField.rolePermission==1" />
                      <span class="ico">
                        <mat-icon>add_a_photo</mat-icon>
                      </span>
                    </div>

                  </ng-container>

                  <ng-container *ngSwitchCase="'Date'">
                    <mat-form-field>
                      <mat-label>{{ grpField.fieldName }}</mat-label>
                      <input [required]="grpField.isRequired" matInput [matDatepicker]="basicDatepicker"
                        placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}"
                        [readonly]="grpField.rolePermission==1" />
                      <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                      <mat-datepicker #basicDatepicker></mat-datepicker>
                    </mat-form-field>
                  </ng-container>

                  <ng-container *ngSwitchCase="'URL'">
                    <mat-form-field>
                      <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                        formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                    </mat-form-field>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Dropdown'">
                    <mat-form-field>
                      <mat-label>{{ grpField.fieldName }}</mat-label>
                      <mat-select [disabled]="grpField.rolePermission==1" [required]="grpField.isRequired"
                        [ngModel]="getddlSelectedVal(grpField.fieldName)" formControlName="{{ grpField.fieldName }}">
                        <mat-option *ngFor="let drp of getdropdownlist(grpField.fieldName)" [value]="drp">
                          {{ drp }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>

                  <ng-container *ngSwitchCase="'MultiSelect'">
                    <mat-form-field class="example-chip-list" *ngIf="grpField.fieldName == 'Tags'">
                      <mat-label>{{ grpField.fieldName }}</mat-label>
                      <mat-chip-list [required]='grpField.isRequired' #chipList aria-label="Tag selection">
                        <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                          (removed)="remove(tag)">
                          {{tag}}
                          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                        <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                          [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          (matChipInputTokenEnd)="add($event)">
                      </mat-chip-list>
                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                        <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                          {{tag}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field *ngIf="grpField.fieldName != 'Tags'">
                      <mat-label>{{ grpField.fieldName }}</mat-label>
                      <mat-select [disabled]="grpField.rolePermission==1" [required]='grpField.isRequired' multiple
                        [ngModel]="getMultiddlSelectedVal(grpField.fieldName)"
                        formControlName="{{ grpField.fieldName }}">
                        <mat-option *ngFor="
                            let muldrp of getMuldropdownlist(grpField.fieldName)
                          " [value]="muldrp">
                          {{ muldrp }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                  </ng-container>

                  <!-- <ng-container *ngSwitchCase="'MultiSelect'">
                    <mat-form-field>
                      <mat-label>{{ grpField.fieldName }}</mat-label>
                      <mat-select [disabled] = "grpField.rolePermission==1" [required]="grpField.isRequired"
                      [ngModel]="getMultiddlSelectedVal(grpField.fieldName)" multiple formControlName="{{ grpField.fieldName }}">
                        <mat-option
                          *ngFor="let muldrp of getMuldropdownlist(grpField.fieldName)"
                          [value]="muldrp">
                          {{ muldrp }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container> -->

                  <!-- <ng-container *ngSwitchCase="'MultiSelect' && grpField.fieldName ==='Tags'">
                    <mat-form-field class="example-chip-list">
                      <mat-label>{{ grpField.fieldName }}</mat-label>
                      <mat-chip-list [required]="grpField.isRequired" #chipList aria-label="Fruit selection">
                        <mat-chip
                          *ngFor="let fruit of filteredFruits"
                          [selectable]="selectable"
                          [removable]="removable"
                          (removed)="remove(fruit)">
                          {{fruit}}
                          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                        <input
                          placeholder="Add Tags"
                          #fruitInput
                          [formControl]="fruitCtrl"
                          [matAutocomplete]="auto"
                          [matChipInputFor]="chipList"
                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          (matChipInputTokenEnd)="add($event)"
                          [readonly] = "grpField.rolePermission==1">
                      </mat-chip-list>
                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                        <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
                          {{fruit}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </ng-container>  -->



                  <ng-container *ngSwitchCase="'Checkbox'">
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <ul class="check">
                      <li *ngFor="let chk of getCheckBoxlist(grpField.fieldName)">
                        <mat-checkbox color="primary" [disabled]="grpField.rolePermission==1"
                          [checked]="isChecked(grpField.fieldName, chk)"
                          (change)="OnChange($event, chk, grpField.fieldID)">
                          {{ chk }}
                        </mat-checkbox>
                      </li>
                    </ul>

                  </ng-container>
                </div>
              </div>
            </mat-expansion-panel>
          </div>

          <div [ngSwitch]="field.fieldTypeName" class="fullw" *ngIf="field.fieldID>0">
            <div *ngSwitchCase="'Textbox'">
              <ng-container *ngIf="field.fieldNames.length > 0">
                <ng-container>

                  <div class="multipleBlock">

                    <div class="multype">
                      <div class="primaryEmail">
                        <mat-form-field class="mulDropdown" appearance="">
                          <mat-select [ngModel]="field.fieldNameID" formControlName="{{ field.fieldName + 'option' }}">

                            <mat-option [value]="names.fieldNameID" *ngFor="let names of field.fieldNames;
                              trackby: fieldNameID">{{ names.fieldName }}</mat-option>
                          </mat-select>


                        </mat-form-field>

                        <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip"
                          *ngIf="field.fieldName == 'Email' && field.isPrimary != true"
                          (click)="MakePrimaryParent($event,field)"> Primary</div>
                        <div class="setPrimaryactive" matTooltipClass="tooltip"
                          *ngIf="field.fieldName == 'Email' && (field.isPrimary == true || field.isPrimary == undefined)">
                          Primary</div>

                      </div>

                      <mat-form-field>
                        <input [required]='field.isRequired' *ngIf="field.fieldName == 'Phone'" matInput
                          placeholder="Add Phone" [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                          mask="(000) 000-0000" [readonly]="field.rolePermission==1" />
                        <input [required]='field.isRequired' *ngIf="field.fieldName == 'Email'" matInput
                          placeholder="Add Email" [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                          [readonly]="field.rolePermission==1"
                          (input)="onChangeEmail($event.target.value,field,field,false)" />
                        <input [required]='field.isRequired' *ngIf="field.fieldName == 'Address'" matInput
                          placeholder="Add Address" [(ngModel)]="field.fieldValue"
                          formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
                      </mat-form-field>

                      <!-- <mat-form-field>
                        <input [required]='field.isRequired'
                        *ngIf="field.fieldName == 'Phone'"
                        matInput
                        placeholder="Add Phone"
                        [(ngModel)]="field.fieldValue"
                        formControlName="{{ field.fieldName }}"
                        mask="(000) 000-0000"
                        [readonly] = "field.rolePermission==1"
                      />
                      <input [required]='field.isRequired'
                        *ngIf="field.fieldName == 'Email'"
                        matInput
                        placeholder="Add Email"
                        [(ngModel)]="field.fieldValue"
                        formControlName="{{ field.fieldName }}"                        
                        [readonly] = "field.rolePermission==1"
                        pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}" required
                      />
                      <input [required]='field.isRequired'
                        *ngIf="field.fieldName != 'Phone' && field.fieldName != 'Email' "
                        matInput
                        placeholder="Add {{field.placeholder}}"
                        [(ngModel)]="field.fieldValue"
                        formControlName="{{ field.fieldName }}"
                        [readonly] = "field.rolePermission==1"
                      />
                     
                      </mat-form-field> -->


                      <div *ngIf="field.fieldName == 'Address'" class="inOline">

                        <div class="divide">
                          <mat-form-field>
                            <input type="text" placeholder="City" [(ngModel)]="cityValue" aria-label="Number" matInput
                              (input)="searchCity($event.target.value)" formControlName="City" [matAutocomplete]="auto"
                              [readonly]="field.rolePermission==1">
                            <mat-autocomplete #auto="matAutocomplete">
                              <mat-option *ngFor="let option of cityOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>

                        <div class="divide">
                          <mat-form-field>

                            <mat-select [disabled]="field.rolePermission==1" [(ngModel)]="stateValue"
                              formControlName="State" placeholder="State">
                              <mat-option>None</mat-option>
                              <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                        <div class="divide">
                          <mat-form-field>
                            <input type="text" [(ngModel)]="zipValue" placeholder="Zip Code" aria-label="Number"
                              matInput (input)="searchZip($event.target.value)" formControlName="ZipCode"
                              [matAutocomplete]="ZipCode" [readonly]="field.rolePermission==1">
                            <mat-autocomplete #ZipCode="matAutocomplete">
                              <mat-option *ngFor="let option of zipOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>




                      </div>

                    </div>
                    <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                      Add more
                    </span>
                  </div>

                  <div class="multipleBlock" *ngIf="field.fieldName == 'Email'">

                    <div class="multype" *ngFor="let element of dynamicArray; let i = index">

                      <div class="primaryEmail">

                        <mat-form-field class="mulDropdown" appearance="">
                          <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                            formControlName="{{ element.fieldName + 'option' }}"
                            placeholder="{{ element.placeholderVal }}">
                            <mat-option value="{{ names.fieldNameID }}" *ngFor="
                              let names of element.fieldNames;
                              trackby: fieldNameID">{{ names.fieldName }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip"
                          *ngIf="element.isPrimary != true" (click)="MakePrimaryChild($event,element)"> Primary</div>
                        <div class="setPrimaryactive" matTooltipClass="tooltip" *ngIf=" element.isPrimary == true">
                          Primary</div>

                      </div>

                      <mat-form-field>
                        <input matInput placeholder="Add Email" [(ngModel)]="element.fieldValue"
                          formControlName="{{ element.fieldName }}" [readonly]="field.rolePermission==1"
                          (input)="onChangeEmail($event.target.value,element,field,true)"
                          pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}" />
                      </mat-form-field>


                    </div>
                    <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                      Add more
                    </span>
                  </div>

                  <div class="multipleBlock" *ngIf="field.fieldName == 'Phone'">
                    <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                      <mat-form-field class="mulDropdown" appearance="">
                        <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                          formControlName="{{ element.fieldName + 'option' }}"
                          placeholder="{{ element.placeholderVal }}">
                          <mat-option value="{{ names.fieldNameID }}" *ngFor="
                              let names of element.fieldNames;
                              trackby: fieldNameID
                            ">{{ names.fieldName }}</mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field>
                        <input matInput placeholder="Add Phone" [(ngModel)]="element.fieldValue"
                          formControlName="{{ element.fieldName }}" mask="(000) 000-0000"
                          [readonly]="field.rolePermission==1" />
                      </mat-form-field>



                    </div>
                    <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                      Add more
                    </span>
                  </div>

                  <div class="multipleBlock" *ngIf="field.fieldName == 'Address'">
                    <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                      <mat-form-field class="mulDropdown" appearance="">
                        <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                          formControlName="{{ element.fieldName + 'option' }}"
                          placeholder="{{ element.placeholderVal }}">
                          <mat-option value="{{ names.fieldNameID }}" *ngFor="
                              let names of element.fieldNames;
                              trackby: fieldNameID
                            ">{{ names.fieldName }}</mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field>
                        <input matInput placeholder="Add Address" [(ngModel)]="element.fieldValue"
                          formControlName="{{ element.fieldName }}" [readonly]="field.rolePermission==1" />
                      </mat-form-field>

                      <div *ngIf="element.address.length>0" class="inOline">
                        <ng-container *ngFor=" let adr of element.address;">
                          <!-- <div class="divide">
                            <mat-form-field> -->
                          <input *ngIf="adr.childFieldType==3" placeholder="City" [ngModel]="adr.fieldValue"
                            aria-label="Number" matInput (input)="searchCity($event.target.value)"
                            formControlName="City{{(i + 1) }}" [matAutocomplete]="auto"
                            [readonly]="field.rolePermission==1">
                          <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let option of cityOption" [value]="option">
                              {{option}}
                            </mat-option>
                          </mat-autocomplete>
                          <!-- </mat-form-field>
                          </div> -->

                          <!-- <div class="divide">
                            <mat-form-field> -->
                          <mat-select [disabled]="field.rolePermission==1" [ngModel]="adr.fieldValue"
                            *ngIf="adr.childFieldType==2" formControlName="State{{ (i + 1) }}" placeholder="State">
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                          </mat-select>
                          <!-- </mat-form-field>
                          </div> -->

                          <!-- <div class="divide">
                            <mat-form-field> -->
                          <input *ngIf="adr.childFieldType==4" placeholder="Zip Code" [ngModel]="adr.fieldValue"
                            aria-label="Number" matInput (input)="searchZip($event.target.value)"
                            formControlName="ZipCode{{ (i + 1) }}" [matAutocomplete]="ZipCode"
                            [readonly]="field.rolePermission==1">
                          <mat-autocomplete #ZipCode="matAutocomplete">
                            <mat-option *ngFor="let option of zipOption" [value]="option">
                              {{option}}
                            </mat-option>
                          </mat-autocomplete>
                          <!-- </mat-form-field>
                          </div> -->


                        </ng-container>

                      </div>
                      <div *ngIf="element.address.length==0" class="inOline">

                        <div class="divide">
                          <mat-form-field>
                            <input placeholder="City" aria-label="Number" matInput
                              (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                              [matAutocomplete]="auto" [readonly]="field.rolePermission==1">
                            <mat-autocomplete #auto="matAutocomplete">
                              <mat-option *ngFor="let option of cityOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>


                        <div class="divide">
                          <mat-form-field>
                            <mat-select [disabled]="field.rolePermission==1" formControlName="State{{ (i + 1) }}"
                              placeholder="State">
                              <mat-option>None</mat-option>
                              <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>


                        <div class="divide">
                          <mat-form-field>
                            <input placeholder="Zip Code" aria-label="Number" matInput
                              (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                              [matAutocomplete]="ZipCode" [readonly]="field.rolePermission==1">
                            <mat-autocomplete #ZipCode="matAutocomplete">
                              <mat-option *ngFor="let option of zipOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>




                      </div>


                    </div>
                    <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                      Add more
                    </span>
                  </div>

                  <div class="multipleBlock" *ngIf="field.fieldName == 'WebSite'">
                    <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                      <mat-form-field class="mulDropdown" appearance="">
                        <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                          formControlName="{{
                            element.fieldName + 'option'
                          }}" placeholder="{{ element.placeholderVal }}">
                          <mat-option value="{{ names.fieldNameID }}" *ngFor="
                              let names of element.fieldNames;
                              trackby: fieldNameID
                            ">{{ names.fieldName }}</mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field>
                        <input matInput placeholder="WebSite" [(ngModel)]="element.fieldValue"
                          formControlName="{{ element.fieldName + (i + 1) }}" [readonly]="field.rolePermission==1" />
                      </mat-form-field>



                    </div>
                    <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                      Add more
                    </span>
                  </div>
                </ng-container>
              </ng-container>
              <mat-form-field *ngIf="field.fieldName == 'Name'">
                <input matInput [required]="field.isRequired" [(ngModel)]="transactionUserName"
                  placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                  [readonly]="field.rolePermission==1" />
                <mat-error *ngIf="
                    myFormGroup.get(field.fieldName).invalid &&
                    (myFormGroup.get(field.fieldName).dirty ||
                      myFormGroup.get(field.fieldName).touched)
                  ">
                  <span *ngIf="myFormGroup.get(field.fieldName).errors.required">This field is mandatory.</span>
                </mat-error>
              </mat-form-field>
              <mat-form-field *ngIf="
                  field.fieldNames.length === 0 && field.fieldName != 'Name'
                ">

                <mat-label>{{ field.fieldName }}</mat-label>
                <input [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                  placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                  [readonly]="field.rolePermission==1" />
              </mat-form-field>
            </div>

            <div *ngSwitchCase="'Textarea'">
              <mat-form-field>
                <mat-label>{{ field.fieldName }}</mat-label>
                <textarea [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                  placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                  [readonly]="field.rolePermission==1"></textarea>
              </mat-form-field>
            </div>

            <div *ngSwitchCase="'Number'">
              <mat-form-field>
                <mat-label>{{ field.fieldName }}</mat-label>
                <input [required]='field.isRequired' matInput (keypress)="numberOnly($event)"
                  placeholder="{{ field.fieldName }}" [(ngModel)]="field.fieldValue"
                  formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
              </mat-form-field>
            </div>

            <div *ngSwitchCase="'Currency'">
              <mat-form-field>
                <mat-label>{{ field.fieldName }}</mat-label>
                <input [required]='field.isRequired' matInput placeholder="{{ field.fieldName }}"
                  [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                  [readonly]="field.rolePermission==1" />
              </mat-form-field>
            </div>

            <div *ngSwitchCase="'Address'">
              <mat-form-field>
                <mat-label>{{ field.fieldName }}</mat-label>
                <input [required]='field.isRequired' matInput placeholder="{{ field.fieldName }}"
                  [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                  [readonly]="field.rolePermission==1" />
              </mat-form-field>
            </div>

            <div *ngSwitchCase="'URL'">
              <mat-form-field>
                <mat-label>{{ field.fieldName }}</mat-label>
                <input [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                  placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                  [readonly]="field.rolePermission==1" />
              </mat-form-field>
            </div>

            <div *ngSwitchCase="'Date'">
              <mat-form-field>
                <mat-label>{{ field.fieldName }}</mat-label>
                <input [required]='field.isRequired' matInput [matDatepicker]="basicDatepicker"
                  [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                  [readonly]="field.rolePermission==1" />
                  <mat-icon *ngIf="field.fieldValue" matDatepickerToggleIcon class="mat-icon-Cleardate" (click)="clearDate(field)">clear</mat-icon>
                <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #basicDatepicker></mat-datepicker>
              </mat-form-field>
            </div>



            <ng-container *ngSwitchCase="'Dropdown'">
              <mat-form-field *ngIf="field.fieldName == 'Type'">
                <mat-label>{{ field.fieldName }}</mat-label>

                <mat-select [required]='field.isRequired' [(ngModel)]="TypeIdDrp"
                  formControlName="{{ field.fieldName }}"
                  (selectionChange)="getCoreUserDetailsOnTypeChange($event,field.fieldName)">
                  <mat-option *ngFor="let typelist of TypeListForDropDown" [value]="typelist.subFolderID">
                    {{typelist.folderName}}
                  </mat-option>
                </mat-select>

              </mat-form-field>

              <mat-form-field *ngIf="field.fieldName != 'Type'">
                <mat-label>{{ field.fieldName }}</mat-label>
                <mat-select [disabled]="field.rolePermission==1" [required]='field.isRequired'
                  [ngModel]="getddlSelectedVal(field.fieldName)" formControlName="{{ field.fieldName }}">
                  <mat-option *ngFor="let drp of getdropdownlist(field.fieldName)" [value]="drp">
                    {{ drp }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>


            <ng-container *ngSwitchCase="'MultiSelect'">

              <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Tags'">
                <mat-label>{{ field.fieldName }}</mat-label>
                <mat-chip-list [required]='field.isRequired' #chipList aria-label="Tag selection">
                  <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                    (removed)="remove(tag)">
                    {{tag}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip>
                  <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                    [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="add($event)">
                </mat-chip-list>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                  <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                    {{tag}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field *ngIf="field.fieldName != 'Tags'">
                <mat-label>{{ field.fieldName }}</mat-label>
                <mat-select [required]='field.isRequired' multiple [ngModel]="getMultiddlSelectedVal(field.fieldName)"
                  formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
                  <mat-option *ngFor="let muldrp of getMuldropdownlist(field.fieldName)" [value]="muldrp">
                    {{ muldrp }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>


            <ng-container *ngSwitchCase="'Checkbox'">
              <div class="checkList">
                <mat-label>{{ field.fieldName }}</mat-label>

                <div class="allCheckList" *ngFor="let chk of getCheckBoxlist(field.fieldName)">
                  <mat-checkbox color="primary" [disabled]="field.rolePermission==1"
                    [checked]="isChecked(field.fieldName, chk)" (change)="OnChange($event, chk, field.fieldID)">
                    {{ chk }}
                  </mat-checkbox>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>


      </form>


    </div>
    <div class="actionBtn" [ngClass]="{'dirty': myFormGroup.dirty}" *ngIf="myFormGroup.dirty || myFormGroup.invalid">
      <button mat-stroked-button class="cancel" (click)="revertForm()">Cancel</button>
      <button mat-flat-button class="calltoaction" [disabled]="!myFormGroup.dirty" type="submit"
        (click)="SaveCoreUserDetails(myFormGroup.value)" color="accent">
        Save
      </button>
    </div>


    <ng-container *ngIf="showTask">
      <app-task3c-tasklists class="inCore" [transactionID]="getTransactionID()" [typeId]="typeIdForTask"
        (OpenTaskLists)="OpenTaskLists($event)" [modulename]="Module" [mainModulename]="mainModuleName"
        (getMyTask)="getMyTask()" [name]="NameForTask" [email]="EmailForTask"
        [imageUrl]="ImageForTask" [entityId]="entityId"  [TypeIdDrp]="TypeIdDrp">
      </app-task3c-tasklists>
    </ng-container>
  </div>
  </mat-card>

  <div class="userdetailsOverlay" (click)="openUserDetail()" [ngClass]="{ open: showUserDetail }">
  </div>
  <!-- User Detail -->

  <!-- Core page Structure -->
  <div class="corepages">

    <div class="allFormHolder">
    
      <div class="allforms">
  
        <!-- <div class="formBtn">
          <button mat-icon-button (click)="openHTML()" ><mat-icon>draw</mat-icon></button>
          <span>Notes</span>
        </div>   -->
        
        <div class="formBtn" *ngFor="let record of FormReportfolderList">
          <button mat-icon-button (click)="openHTML(record)" matTooltip="{{record.formAlias}}">
            <mat-icon>{{record.formIcon}}</mat-icon>  </button>
            <span>{{record.formAlias}}</span>  
        </div>  
  
        <!-- <div class="formBtn">
          <button mat-icon-button ><mat-icon>draw</mat-icon></button>
          <span>Meeting</span>
        </div>   -->
          <!-- <button mat-icon-button matTooltip="form name"><mat-icon>text_snippet</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>view_agenda</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>format_align_center</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>draw</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>text_snippet</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>view_agenda</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>format_align_center</mat-icon></button>
          <button mat-icon-button matTooltip="form name" ><mat-icon>border_right</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>font_download</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>rectangle</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>border_right</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>align_vertical_top</mat-icon></button>
  
          <button mat-icon-button matTooltip="form name"><mat-icon>draw</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>text_snippet</mat-icon></button> -->
          <!-- <button mat-icon-button matTooltip="form name"><mat-icon>view_agenda</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>format_align_center</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>border_right</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>font_download</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>rectangle</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>border_right</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>align_vertical_top</mat-icon></button> -->
  
          <!-- <button mat-icon-button matTooltip="form name"><mat-icon>draw</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>text_snippet</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>view_agenda</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>format_align_center</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>border_right</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>font_download</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>rectangle</mat-icon></button>
          <button mat-icon-button matTooltip="form name"><mat-icon>border_right</mat-icon></button>
          <button mat-icon-button matTooltip="form name"  ><mat-icon>align_vertical_top</mat-icon></button> -->
      </div>
  
     
  
    </div>
    
    <div class="nextpreviuos">
      <button mat-icon-button [disabled]="PreviousButton" (click)="PreviousRecord()" matTooltipClass="tooltip"
        matTooltip="Previous">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>

      <button mat-icon-button [disabled]="NextButton" (click)="NextRecord()" matTooltipClass="tooltip"
        matTooltip="Next">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>

    <!-- <mat-tab-group animationDuration="0ms" (selectedTabChange)="getAllFoldersField($event)">
      <mat-tab label="Documents">
        <app-documents
          (openDocumentDetail)="getDocumentDetail($event)"
          (showShareFile)="getShareFile($event)"
          (documentViewer)="getdocumentViewer($event)"
          (htmlData)="gethtmlData($event)"
          [transactionID]="getTransactionID()"
          [folderID]="folderID">
        </app-documents>
      </mat-tab>
      <mat-tab label="Activity">
        <app-touches *ngIf="showTouches"></app-touches>
      </mat-tab>
     
    </mat-tab-group> -->

    <mat-tab-group animationDuration="0ms" (selectedTabChange)="getAllFoldersField($event)"
      [selectedIndex]="matTabIndex">
      <mat-tab label="Documents">
        <app-documents (openDocumentDetail)="getDocumentDetail($event)" (showShareFile)="getShareFile($event)"
          (documentViewer)="getdocumentViewer($event)" (htmlData)="gethtmlData($event)"
          [transactionID]="getTransactionID()" [folderID]="folderID"
          (openAIDetail)="getAIDetails($event)" >
        </app-documents>
      </mat-tab>
      <mat-tab label="Activity">
        <app-touches *ngIf="showTouches"></app-touches>
      </mat-tab>

      <mat-tab label="Custom Info">
        <app-customInfo3c *ngIf="showCustomInfo" [mainModulename]="mainModuleName"></app-customInfo3c>
      </mat-tab>

      <mat-tab label="Tasks">
        <app-task3c *ngIf="showTask" [modulename]="Module" [mainModulename]="mainModuleName"
          [transactionID]="transactionIDForTask" [typeId]="typeIdForTask" [name]="NameForTask" [email]="EmailForTask"
          [imageUrl]="ImageForTask" [entityId]="entityId"  [TypeIdDrp]="TypeIdDrp">
        </app-task3c>
      </mat-tab>

      <mat-tab label="Email">
        <app-email *ngIf="showEmail" [mainModulename]="mainModuleName"></app-email>
      </mat-tab>
      
      <mat-tab label="Form Reports">
        <app-htmlReport3c *ngIf="showFormReports" [mainModulename]="mainModuleName">
        </app-htmlReport3c>       
      </mat-tab>
    

      <!-- <mat-tab label="Task">
      <app-task
        (createTask)="getcreateTask($event)"
        (showLinkPI)="getLinkPI($event)"
        (taskDetail)="getTaskDetail($event)"
      ></app-task>
    </mat-tab> -->

      <!-- <mat-tab label="Process Intelligence">
      <app-process-intelligence></app-process-intelligence>
    </mat-tab>

    <mat-tab label="Photos">
      <app-photos></app-photos>
    </mat-tab>

    <mat-tab label="Shared">
      <app-request-document></app-request-document>
    </mat-tab> -->

    </mat-tab-group>

  </div>
  <!-- Core page Structure -->
  <!-- Contact List -->
  <mat-card class="contactlist" [ngClass]="{ open: showContactList }">
    <app-associate-contact [datalist]="contactCoreListing" [contactID]="transactionID"></app-associate-contact>
  </mat-card>

  <div class="contactlistOverlay" (click)="openContactList()" [ngClass]="{ open: showContactList }">
  </div>
  <!-- Contact List -->

  <!-- All OTHER COMPONENETS -->

  <!-- Create Activity -->
  <app-create-touches (closeShowCreate)="closeTouches($event)" [ngClass]="{ open: showCreateTouches }">
  </app-create-touches>

  <!-- Create Activity -->

  <!-- document detail -->

  <app-documentdetail [ngClass]="{ open: openDocumentDetail }" (closeEmit)="getClose($event)"
    (documentViewer)="getdocumentViewer($event)" (closeEmit)="getClose($event)">
  </app-documentdetail>

  <!-- document detail-->

  <!-- Document Viewer -->
  <app-document-viewer (getCloseDocumentViewer)="getCloseDocumentViewer($event)" [ngClass]="{ open: documentViewer }"
    [folderID]="folderID">
  </app-document-viewer>

  <!-- Document Viewer-->


  <!-- Document Viewer -->
  <app-html-data (getCloseHtmlData)="getCloseHtmlData($event)" [ngClass]="{ open: htmlData }" [folderID]="folderID">
  </app-html-data>
  <!-- Document Viewer-->

  <!-- Share Document -->
  <app-request-File [mainModuleName]="mainModuleName" [ngClass]="{ open: showShareFile }"
    (closeShareFile)="getCloseShareFile($event)">
  </app-request-File>


  <!-- Contact Detail -->
  <app-contact-detail (closeDetail)="getCloseDetail($event)" [ngClass]="{ open: showContactdetail }">
  </app-contact-detail>
  <!-- Contact Detail -->

  <!-- Create Task -->
  <app-create-task [ngClass]="{ open: showCreateTask }" (closeCreateTask)="closeCreateTask($event)">
  </app-create-task>
  <!-- Create Task -->

  <!-- In Task LINK PI -->
  <app-task-detail [ngClass]="{ open: showTaskDetail }" (closeTaskDetail)="closeTaskDetail($event)">
  </app-task-detail>
  <!-- In Task LINK PI -->

  <!-- In Task LINK PI -->
  <app-link-pi [ngClass]="{ open: showLinkPI }" (closeLinkPI)="closeLinkPI($event)">
  </app-link-pi>
  <!-- In Task LINK PI -->

  <app-ai-details *ngIf="openAIToolDetail"
  [ngClass]="{ open: openAIToolDetail }"
  [pdfURL]="azureblobPath"
  [documentId]="documentsId"
  [typeIdCCC]="typeIdForTask"
  [documentName]="documentNames"
  [cType]="cType"
  [transactionID3c]="transactionIDForTask"
  [docFrom]="cType"
  [Name]="NameForTask"
  [Email]="EmailForTask"
  (closeAIToolEmit)="getCloseAIToolDetail()">
  </app-ai-details>


</div>